export class Settings {
    public constructor(settings: any) {
        Object.assign(this, settings);
    }
}
export interface Settings {
    base: string;
    url(url: string): string;
    name: string;
    author: string;
    program: string;
    description: string;
    minDate: string;
    mainMenu: Array<{ icon: [string, string]; title: string; to: string; exact: boolean }>;
    errorPages: {
        default: { icon: [string, string]; title: string; message: string; statusCode: number };
        [code: string]: { icon: [string, string]; title: string; message: string; statusCode: number };
    };
    card: string;
    headerLogo: string;
    footerLogo: string;
    footerDrugLogo: string;
    footerPharmaLogo: string;
    cardTypeQuestionId: string;
    cardTypeAnswerId: string;
    programId: string;
    surveyId: string;
    isFederalQuestionId: string;
    isFederalAnswerId: string;
    isFederalAnswerYesId: string;
    patientDiagnosisQuestionId: string;
    patientDiagnosisD89811AnswerId: string;
    patientDiagnosisD89812AnswerId: string;
    patientDiagnosisD89813AnswerId: string;
    patientDiagnosisT8609AnswerId: string;

    doesAgreeMarketingQuestionId: string;
    doesAgreeMarketingAnswerId: string;
    triangleUp: string;
    triangleDown: string;
    lockEnabled: string;
    lockPassword: string;
}
